{
  "locale": "Deutsch",
  "sidebar": {
    "title": "Anfrage zum Datenaustausch",
    "issuanceTitle": "Anfrage zum Hinzufügen von Daten",
    "authenticationTitle": "Authentifizierungsanfrage",
    "description": "{clientName} fragt verifizierte personenbezogene Daten aus Ihrer Identitäts-App an. Überprüfen Sie die Details unten und genehmigen oder lehnen Sie diese Anfrage in Ihrer Identitäts-App ab.",
    "issuanceDescription": "{clientName} fügt verifizierte Daten zu Ihrer Identitäts-App hinzu. Überprüfen Sie die Details unten und bestätigen Sie in Ihrer Identitäts-App, ob Sie diese akzeptieren möchten.",
    "authenticationDescription": "{clientName} möchte sich mit Ihrer Identitäts-App authentifizieren.",
    "descriptionFallback": "Ein Dienst fragt verifizierte personenbezogene Daten aus Ihrer Identitäts-App an. Überprüfen Sie die Details unten und genehmigen oder lehnen Sie diese Anfrage in Ihrer Identitäts-App ab.",
    "issuanceDescriptionFallback": "Ein Dienst fügt verifizierte Daten zu Ihrer Identitäts-App hinzu. Überprüfen Sie die Details unten und bestätigen Sie in Ihrer Identitäts-App, ob Sie diese akzeptieren möchten.",
    "authenticationDescriptionFallback": "Ein Dienst möchte sich mit Ihrer Identitäts-App authentifizieren.",
    "stepsTitle": "Schritte zum Abschließen",
    "stepShareData": "Daten mit {clientName} teilen",
    "stepAuthenticate": "Authentifizieren für {clientName}",
    "stepReceiveData": "Daten von {clientName} empfangen",
    "stepGeneric": "Erforderliche Schritte abschließen",
    "defaultClientName": "dem Dienst",
    "requestedDataTitle": "Die folgenden Daten werden angefragt",
    "issuedDataTitle": "Die folgenden Daten werden ausgestellt",
    "reviewNotice": "Sie überprüfen und genehmigen die genauen Daten in Ihrer Identitäts-App, bevor etwas geteilt wird.",
    "issuanceReviewNotice": "Sie überprüfen und genehmigen die genauen Daten in Ihrer Identitäts-App, bevor etwas hinzugefügt wird.",
    "indeterminateHint": "Die angeforderten Daten werden sichtbar, nachdem Sie eine Identitäts-App ausgewählt haben",
    "terms": "Bedingungen",
    "termsLink": "Bedingungen",
    "privacyLink": "Datenschutzerklärung",
    "showAll": "Alle anzeigen",
    "purposeStatementTitle": "Warum Ihre Daten benötigt werden",
    "retentionPolicyTitle": "Wie Ihre Daten behandelt werden"
  },
  "footer": {
    "powered": "Bereitgestellt von",
    "terms": "Bedingungen"
  },
  "topBar": {
    "openMenu": "Menü öffnen",
    "closeMenu": "Menü schließen",
    "help": "Hilfe",
    "language": "Sprache"
  },
  "app": {
    "error": "Fehler",
    "loadingTitle": "Wird geladen",
    "loadingHint": "Einen Moment bitte"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Suchen",
    "noResults": "Keine Ergebnisse"
  },
  "init": {
    "title": "Anfrage wird verarbeitet",
    "hint": "Die Sitzung wird vorbereitet"
  },
  "pairing": {
    "title": "Nächster Schritt wird vorbereitet",
    "hint": "Die Sitzung wird vorbereitet",
    "codeLabel": "Überprüfen Sie den folgenden Code in Ihrer Identitäts-App",
    "confirm": "Kopplung bestätigen"
  },
  "waitingForPresentation": {
    "title": "Fahren Sie in Ihrer Identitäts-App fort",
    "hint": "Bitte überprüfen und genehmigen Sie die Anfrage in Ihrer Identitäts-App"
  },
  "agentStart": {
    "title": "Weiter in {appName}",
    "subtitle": "Um Ihre Daten sicher zu teilen, scannen Sie diesen QR-Code mit {appName}, um die Anfrage zu überprüfen und zu genehmigen.",
    "issuanceSubtitle": "Um die Daten sicher zu empfangen, scannen Sie diesen QR-Code mit {appName}, um die Anfrage zu überprüfen und zu genehmigen.",
    "step1": "{appName} öffnen",
    "step2": "Auf das Scanner-Symbol klicken",
    "step3": "Diesen QR-Code scannen",
    "changeApp": "Identitäts-App wechseln",
    "installInstructions": "Installationsanleitung",
    "cancel": "Abbrechen",
    "needHelp": "Brauchen Sie Hilfe?",
    "redirectSubtitle": "Klicken Sie auf die Schaltfläche unten, um {appName} zu öffnen und die Anfrage zu genehmigen.",
    "issuanceRedirectSubtitle": "Klicken Sie auf die Schaltfläche unten, um {appName} zu öffnen und die Anfrage zu genehmigen.",
    "redirectButton": "Weiter",
    "mobileSubtitle": "Um Ihre Daten sicher zu teilen, fahren Sie in {appName} fort, um die Anfrage zu überprüfen und zu genehmigen.",
    "issuanceMobileSubtitle": "Um die Daten sicher zu empfangen, fahren Sie in {appName} fort, um die Anfrage zu überprüfen und zu genehmigen.",
    "openApp": "{appName} öffnen",
    "showQr": "QR-Code anzeigen"
  },
  "done": {
    "disclosure": {
      "title": "Daten wurden erfolgreich geteilt",
      "subtitle": "Die Seite wird in wenigen Sekunden automatisch geschlossen.",
      "subtitleCloseTab": "Daten erfolgreich geteilt. Sie können diese Seite schließen."
    },
    "issuance": {
      "title": "Daten erfolgreich empfangen",
      "subtitle": "Die Seite wird in wenigen Sekunden automatisch geschlossen.",
      "subtitleCloseTab": "Daten erfolgreich empfangen. Sie können diese Seite schließen."
    },
    "redirecting": "Weiterleitung...",
    "completeRedirect": "Abschließen und weiterleiten",
    "redirectFailed": "Die automatische Weiterleitung hat nicht funktioniert. Tippen Sie unten, um fortzufahren."
  },
  "abort": {
    "cancel": {
      "title": "Prozess gestoppt",
      "subtitle": "Sie haben den Prozess gestoppt. Sie können jederzeit neu starten."
    },
    "techFail": {
      "title": "Etwas ist schiefgelaufen",
      "subtitle": "Wir konnten den Prozess aufgrund eines technischen Problems nicht abschließen."
    },
    "timeout": {
      "title": "Sitzung abgelaufen",
      "subtitle": "Diese Sitzung wurde nach einer Zeit der Inaktivität beendet. Schließen Sie diese Seite und starten Sie den Prozess neu, um fortzufahren."
    },
    "networkLoss": {
      "title": "Verbindung verloren",
      "subtitle": "Ihre Internetverbindung wurde unterbrochen. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut."
    },
    "backendDowntime": {
      "title": "Dienst vorübergehend nicht verfügbar",
      "subtitle": "Der Dienst wird derzeit gewartet. Bitte versuchen Sie es später erneut."
    },
    "appUnavailable": {
      "title": "Identitäts-App nicht verfügbar",
      "subtitle": "Wir konnten keine Verbindung zur ausgewählten Identitäts-App herstellen. Die App ist möglicherweise vorübergehend nicht verfügbar. Sie können eine andere Identitäts-App ausprobieren oder es später erneut versuchen."
    },
    "selectDifferentApp": "Andere Identitäts-App auswählen",
    "confirmTitle": "Prozess stoppen?",
    "confirmMessage": "Sind Sie sicher, dass Sie stoppen möchten? Sie können jederzeit neu starten, wenn Sie später fortfahren möchten.",
    "confirmCancel": "Abbrechen",
    "confirmStop": "Prozess stoppen",
    "goBack": "Zurück",
    "leave": "Verlassen",
    "closePage": "Seite schließen",
    "restart": "Neu starten",
    "retry": "Erneut versuchen"
  },
  "appPicker": {
    "title": "Unterstützte Identitäts-Apps",
    "subtitle": "Die folgenden Identitäts-Apps können verwendet werden, um die Anfrage zu überprüfen und zu genehmigen",
    "searchPlaceholder": "Suchen...",
    "sectionLastUsed": "Zuletzt verwendet",
    "sectionRecommended": "Empfohlen",
    "sectionAZ": "A-Z",
    "noResults": "Keine Apps entsprechen Ihrer Suche",
    "filterTitle": "Nach Land filtern",
    "filterClear": "Alle löschen",
    "filterDone": "Fertig"
  },
  "faq": {
    "helpQuestion": "Frage",
    "moreHelp": "Weitere Hilfe",
    "close": "Schließen",
    "whatAreWallets": {
      "title": "Was sind Identitäts-Apps?",
      "body": "Mit einer Identitäts-App haben Sie die Kontrolle über Ihre eigenen Daten — Sie allein entscheiden, welche Daten Sie mit wem und wann teilen. Ihre Daten werden von einem verifizierten Aussteller abgerufen und zusammen mit einer digitalen Signatur in der App gespeichert, die deren Korrektheit garantiert.\n\nWenn Sie Ihre Daten mit einem Dritten teilen, wird die digitale Signatur mitgesendet, damit die empfangende Partei die Echtheit überprüfen kann. Ihre Daten werden normalerweise nur auf Ihrem eigenen Telefon gespeichert und können bei Bedarf leicht erneut abgerufen werden.\n\nSeien Sie sich immer bewusst, dass es Ihre Verantwortung ist, sorgfältig auszuwählen, mit wem Sie Ihre Daten teilen."
    },
    "whyNotSupported": {
      "title": "Warum wird meine Identitäts-App nicht unterstützt?",
      "body": "Es kann vorkommen, dass Ihre spezifische Identitäts-App nicht verfügbar ist, da die empfangende Partei oder unsere Plattform sie derzeit nicht unterstützt. Wir arbeiten ständig daran, unser Angebot an unterstützten Apps zu erweitern.\n\nWenn Ihre App nicht aufgeführt ist, können Sie immer eine der anderen unterstützten Identitäts-Apps installieren und verwenden."
    },
    "howDataProtected": {
      "title": "Wie werden meine Daten geschützt?",
      "body": "Identitäts-Apps stellen sicher, dass Sie immer die Kontrolle darüber behalten, mit wem Sie Ihre Daten wann teilen. Diese Apps bieten Ihnen normalerweise einen Überblick darüber, welche Daten Sie mit wem und wann geteilt haben.\n\nVer.iD sendet Ihre Daten direkt an die empfangende Partei und prüft nur, ob sie korrekt übermittelt wurden. Alle Daten werden gemäß der Datenschutz-Grundverordnung (DSGVO) verarbeitet. Die empfangende Partei wendet ihre eigenen Regeln zum Schutz Ihrer Daten an und wird dies mit Ihnen kommunizieren.\n\nSeien Sie sich immer bewusst, dass es Ihre Verantwortung ist, sorgfältig auszuwählen, mit wem Sie Ihre Daten teilen."
    },
    "howObtainData": {
      "title": "Wie kann ich Daten in meine App einfügen?",
      "body": "Jede Identitäts-App hat eine eigene Methode zur Datensammlung. Die meisten Apps haben eine Schaltfläche, mit der Sie Daten hinzufügen können. In einigen Fällen sind damit Kosten verbunden.\n\nFollgen Sie den Anweisungen in der App, um Ihre Daten sicher zu sammeln. Möglicherweise werden Sie auf Regierungswebsites weitergeleitet oder müssen Dokumente wie Pässe oder Führerscheine scannen.\n\nWenn Sie keine direkte Möglichkeit sehen, die richtigen Daten einzufügen, überprüfen Sie die Dokumentationsseite oder wenden Sie sich an den App-Anbieter. Sie können auch eine andere Identitäts-App ausprobieren."
    },
    "whyRedirection": {
      "title": "Warum werde ich weitergeleitet?",
      "body": "Einige Identitäts-Apps erfordern eine Weiterleitung auf ihre eigene Website, damit Ihre Daten gemäß deren Standards geteilt werden und die beste Benutzererfahrung in einer vertrauten Umgebung gewährleistet wird.\n\nNach erfolgreichem Teilen werden Sie automatisch zu Ver.iD zurückgeleitet, wo Ihre Daten auf Ihre Bestätigung warten, bevor sie an die empfangende Partei gesendet werden. Ein digitaler Beleg ist normalerweise in Ihrer Identitäts-App zu finden.\n\nWenn der Prozess fehlschlägt oder abgebrochen wird, werden Sie ebenfalls zurückgeleitet und können es erneut versuchen."
    }
  },
  "dataReview": {
    "title": "Bitte überprüfen Sie die Daten",
    "subtitleDisclosure": "Bevor Sie teilen, nehmen Sie sich einen Moment Zeit, um die Daten zu überprüfen, die mit {clientName} geteilt werden.",
    "subtitleIssuance": "Bevor Sie akzeptieren, nehmen Sie sich einen Moment Zeit, um die Daten zu überprüfen, die Sie von {clientName} erhalten.",
    "issuedBy": "Daten ausgestellt von",
    "attribute": "Attribut",
    "value": "Wert",
    "cancel": "Abbrechen",
    "acceptShare": "Akzeptieren",
    "acceptReceive": "Akzeptieren",
    "unknownClient": "dem Dienst",
    "loadingNames": "Datennamen werden geladen...",
    "errorLoadingNames": "Datennamen konnten nicht geladen werden. Bitte versuchen Sie es erneut."
  },
  "mobileFlowStart": {
    "startVerification": "Weiter",
    "selectApp": "Identitäts-App auswählen"
  },
  "requestedDataModal": {
    "title": "Angeforderte Daten",
    "subtitle": "Sie überprüfen und genehmigen diese Anfrage in Ihrer Identitäts-App.",
    "attribute": "Attribut",
    "description": "Beschreibung",
    "issuedBy": "Daten ausgestellt von",
    "close": "Schließen"
  },
  "demo": {
    "title": "Demo-Umgebung",
    "description": "Sie verwenden eine interaktive Demo von Ver.iD. Diese Umgebung dient ausschließlich zu Demonstrationszwecken."
  },
  "installInstructions": {
    "title": "{appName} installieren",
    "subtitle": "Besuchen Sie den App Store oder Play Store auf Ihrem Telefon, um {appName} Identitäts-App zu installieren. Scannen Sie den Code, um direkt die Store-Seite zu öffnen und die App zu installieren.",
    "close": "Schließen",
    "unavailableTitle": "Anleitung nicht verfügbar",
    "unavailableBody": "Leider haben wir derzeit keine Installationsanleitung für diese App verfügbar. Versuchen Sie, manuell im App Store nach der App zu suchen, um fortzufahren."
  }
}
